import React, { useState } from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material"
import { BaseProduct, Batch, batchService } from "services/batchService"
import { toast } from "react-toastify"

interface DialogDeleteBatchProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  batchToDelete: Batch | null
  selectedProduct: BaseProduct | undefined
}

const DialogDeleteBatch: React.FC<DialogDeleteBatchProps> = ({
  open,
  onClose,
  onConfirm,
  batchToDelete,
  selectedProduct,
}) => {
  const [isDeleting, setIsDeleting] = useState(false)

  const confirmDeleteBatch = async () => {
    if (!batchToDelete) return
    try {
      setIsDeleting(true)
      await batchService.delete(batchToDelete.id)
      toast.success(`Lote ${batchToDelete.batchId} excluído com sucesso!`)
      onConfirm()
    } catch (error: any) {
      toast.error(error?.message ?? "Erro ao excluir lote. Tente novamente.")
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Confirmar exclusão de lote para {selectedProduct?.productBaseName}</DialogTitle>
      <DialogContent>
        <Typography>Tem certeza que deseja excluir o lote {batchToDelete?.batchId}?</Typography>
      </DialogContent>
      <DialogActions>
        <Button style={{ color: "#000" }} onClick={onClose} disabled={isDeleting}>
          Cancelar
        </Button>
        <Button
          onClick={confirmDeleteBatch}
          variant="contained"
          color="error"
          disabled={isDeleting}
          startIcon={isDeleting ? <CircularProgress size={20} color="inherit" /> : null}
        >
          {isDeleting ? "Excluindo..." : "Excluir"}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogDeleteBatch
